import * as Const from '../constants/index';
import State from '../interfaces/state/ManagerEventListenerState';

const initState: State = {
  isSwitchOffManagerEventListener: false,
};

export default function managerEventListener(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.SWITCH_MANAGER_EVENT_LISTENER_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.SWITCH_ON_MANAGER_EVENT_LISTENER:
      return {
        ...state,
        isSwitchOffManagerEventListener: true,
      };

    default:
      return state;
  }
}
